class SubscriberController extends AbstractEntityEditController
	@register()
	@inject '$stateParams',
		'$uibModal'
		'translate'
		'subscribers'
		'Guid'
		'entityTypes': 'BACKEND_SUBSCRIBER_ENTITY_TYPE'
		'periodTypes': 'BACKEND_SUBSCRIBER_PERIOD'
		'DayTallySubscriberService'
		'SaftSubscriberService'
		'SalesReportSubscriberService'
		'TicketsPurchasedSubscriberService'
		'CopyService'
		'ShopRepository'
		'RegisterRepository'
		'SubscriberRepository'

	initialize: ->
		if _.isEmpty(@$stateParams.id)
			return

		services =
			"#{@entityTypes.DAY_TALLY}": @DayTallySubscriberService
			"#{@entityTypes.SAFT}": @SaftSubscriberService
			"#{@entityTypes.SALES_REPORT}": @SalesReportSubscriberService
			"#{@entityTypes.TICKETS_PURCHASED}": @TicketsPurchasedSubscriberService

		@type = @$stateParams.id
		@typeName = @translate('wbo.subscriber.type.' + @type.toLowerCase())
		@service = services[@type]

		@mainCrud.showDelete = false
		@mainCrud.isNewEntity = false
		@mainCrud.entityType = 'wbo.subscription'
		@mainCrud.entityTitle = 'wbo.subscription'
		@mainCrud.afterHeaderTitle = @typeName

		if @service.getPeriods() == null
			@mainCrud.description = 'wbo.subscriber.description.live'
		else
			@mainCrud.description = 'wbo.subscriber.description.period'

		@useShop = @service.hasShop()
		@useRegister = @service.hasRegister()

	save: ->
		@SubscriberRepository
			.all(
				_.map(
					@subscribers,
					(subscriber) =>
						subscriberCopy = @CopyService.copy(subscriber)

						delete subscriberCopy.shop
						delete subscriberCopy.register

						return switch subscriberCopy.$$state
							when 'create' then @SubscriberRepository.save(subscriberCopy, true)
							when 'update' then @SubscriberRepository.save(subscriberCopy, false)
							when 'delete' then @SubscriberRepository.delete(subscriberCopy.id)
							else
								null
				)
			)
			.then =>
				@subscribers = _.reject(@subscribers, {'$$state': 'delete'})

				for subscriber in @subscribers
					delete subscriber.$$state

				@mainCrud.parent_form.$setPristine()
				@mainCrud.parent_form.$setUntouched()

				@ToastService.add(@typeName, @translate(@mainCrud.entityTitle), @translate('alert.updated'), 'success')

				@$timeout(
					=>
						@mainCrud.saving = false
						@mainCrud.isNewEntity = false
				)
			.catch (response) =>
				@handleErrors response

	editSubscriber: (originSubscriber) ->
		periodsMap = @service.getPeriods()

		if periodsMap != null
			periods = _.map(
				periodsMap,
				(period) =>
					return {
						id: period
						name: @translate("general.period.#{period.toLowerCase()}")
					}
			)
		else
			periods = null
			originSubscriber.period = @periodTypes.LIVE

		@$uibModal
			.open
				templateUrl: '@app/subscriber/subscriber.edit.modal.view.html'
				controllerAs: 'modal'
				controller: ($uibModalInstance, subscriber, periods, service) ->
					$onInit: ->
						@subscriber = subscriber
						@service = service
						@$uibModalInstance = $uibModalInstance
						@periods = periods
				resolve:
					subscriber: => angular.copy originSubscriber
					service: => @service
					periods: => periods
			.result
			.then (subscriber) =>
				fields = ['email', 'register_id', 'shop_id', 'period']

				for field in fields
					originSubscriber[field] = subscriber[field]

				@onEdit(originSubscriber)

	addSubscriber: ->
		subscriber =
			$$state: 'create'
			id: @Guid.generate()
			shop_id: null
			register_id: null
			entity_type: @type

		@editSubscriber(subscriber)

	removeSubscriber: (subscriber) ->
		isNew = subscriber.$$state == 'create'
		subscriber.$$state = 'delete'

		if isNew
			@subscribers = _.reject(@subscribers, {id: subscriber.id})
		else
			@triggerFormChange()

	onEdit: (subscriber) ->
		if subscriber.$$state != 'create'
			subscriber.$$state = 'update'

		@triggerFormChange()
		@updateRelation(subscriber, 'shop', @ShopRepository)
		@updateRelation(subscriber, 'register', @RegisterRepository)

		if !_.find(@subscribers, {id: subscriber.id})
			@subscribers.push(subscriber)

	updateRelation: (subscriber, relation, repository) ->
		referenceField = "#{relation}_id"

		if subscriber[referenceField] == null
			subscriber[relation] = null

			return

		if _.isEmpty(subscriber[relation]) || subscriber[relation].id != subscriber[referenceField]
			repository
				.getEntity(subscriber[referenceField])
				.then (response) ->
					subscriber[relation] = response
				.catch ->
					# Do not move this away as "default", otherwise UI will temporary show `deleted (**ID**)`
					subscriber[relation] = null
